/* import __COLOCATED_TEMPLATE__ from './topic-category.hbs'; */
import Component from "@ember/component";
// Injections don't occur without a class
export default Component.extend();
